const SiljukBanner = () => {
     return (
          <div className="banner-container">
               <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@700;900&display=swap');

        .banner-container {
          font-family: 'Noto Sans KR', sans-serif;
          width: 100%;
          max-width: 1600px;
          margin: 10px auto;
          // background-color: #ffffff;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          padding: 0px 20px;
        }

        .mid-container {
          display: flex;
          overflow: hidden;
          border-radius: 8px;
          background-color: #ffffff;
        }

        .banner-link {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding: 20px 40px;
          background-color: #43b8af;
          text-decoration: none;
          color: white;
          flex-shrink: 0;
          clip-path: polygon(0 0, 100% 0, 85% 100%, 0% 100%);
          transition: background-color 0.3s ease;
        }

        .banner-link:hover {
          background-color: #3aa39b;
        }

        .channel-title {
          font-size: 24px;
          font-weight: 900;
          margin-bottom: 8px;
        }

        .channel-title .text-dark {
          color: #2c3e50;
        }

        .channel-title .text-light {
          color: #ffffff;
        }

        .channel-url {
          font-size: 16px;
          font-weight: 700;
          opacity: 0.9;
        }

        .banner-text-wrapper {
          display: flex;
          align-items: flex-start;
          justify-content: center;
          padding: 20px 40px;
          flex-grow: 1;
          gap: 15px;
        }

        .text-main {
          font-size: 36px;
          font-weight: 900;
          color: #2c3e50;
          font-style: italic;
          flex-shrink: 0;
        }

        .text-highlight {
          font-size: 60px;
          font-weight: 900;
          background: linear-gradient(to right, #43b8af, #3da49b);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          line-height: 1.1;
        }

        @media (max-width: 768px) {
          .banner-container {
            padding: 15px;
          }

          .mid-container {
            flex-direction: column;
          }

          .banner-link {
            clip-path: none;
            align-items: center;
            padding: 25px 20px;
            border-radius: 8px 8px 0 0;
          }

          .banner-text-wrapper {
            flex-direction: column;
            align-items: center;
            padding: 30px 20px;
            text-align: center;
            gap: 10px;
          }

          .channel-title {
            font-size: 20px;
          }

          .channel-url {
            font-size: 14px;
          }

          .text-main {
            font-size: 28px;
          }

          .text-highlight {
            font-size: 48px;
          }
        }
      `}</style>

               <div className="mid-container">
                    <a
                         href="https://t.me/allsiljuk"
                         className="banner-link"
                         target="_blank"
                         rel="noopener noreferrer"
                    >
                         <span className="channel-title">
                              <span className="text-dark">채널가</span>
                              <span className="text-light">기</span>
                         </span>
                         <span className="channel-url">
                              https://t.me/allsiljuk
                         </span>
                    </a>

                    <div className="banner-text-wrapper">
                         <span className="text-main">실적공시는</span>
                         <span className="text-highlight">빠짐없이</span>
                    </div>
               </div>
          </div>
     );
};

export default SiljukBanner;
